import { createContext, useContext, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

// Create context object and make available through custom hook
const UtilsContext = createContext();
export const useUtils = () => useContext(UtilsContext)

const UtilsProvider = ({ children }) => {

  /**
   * 
   * @param {*} param0 
   * @returns 
   */

  // Alert snackbar severity options
  const alertSeverityTypes = {
    error: "error",
    warning: "warning",
    info: "info",
    success: "success",
  }

  // Alert snackbar state
  const [ alertMessage, setAlertMessage ] = useState('');
  const [ alertSeverity, setAlertSeverity ] = useState(alertSeverityTypes.info);

  function createAlert(message, severity) {
    // Set values to trigger display of alert component
    setAlertMessage(message);
    setAlertSeverity(severity);
  };

  // Form control and input change handling
  const [formState, setFormState] = useState({});
  const [formError, setFormError] = useState(null);

  function resetFormState() {
    setFormState({});
    setFormError(null);
  }
  // Form input handling
  function onChange(e) {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
    setFormError(null);
  }

  // Class name joining for Tailwind state mutation
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  // Capitalise all words in a string
  const capitaliseWords = (str) => {
    const capitalisedWordsArray = str.toLowerCase().split(" ").map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1));
    return capitalisedWordsArray.join(" ");
  };

  const contextValue = {
    alertMessage,
    setAlertMessage,
    alertSeverity,
    setAlertSeverity,
    alertSeverityTypes,
    createAlert,
    formState,
    setFormState,
    resetFormState,
    onChange,
    formError,
    setFormError,
    classNames,
    capitaliseWords,
    uuidv4,
    publicIpAddress: "not set",
  }

  return (
    <UtilsContext.Provider value={ contextValue }>
      {children}
    </UtilsContext.Provider>
  );
}

export default UtilsProvider;